module.exports = __webpack_public_path__ + "img/Drache.86020557.svg";